"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Index = void 0;
class Index {
    algo;
    type;
    opts;
}
exports.Index = Index;
//# sourceMappingURL=aes.js.map